























































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import ChangeClicker from '@/components/lfs/NewStatistics/Elements/ChangeClicker.vue';
import Highcharts from "highcharts";
import {locales} from "@/helpers/locales";
import IQuestion from "@/components/icons/IQuestion.vue";
import TooltipSimple from "@/components/UI/TooltipSimple.vue";

@Component({
  name: 'DataPerformanceStandmansFromSurvey',
  components: {TooltipSimple, IQuestion, ChangeClicker}
})
export default class DataPerformanceStandmansFromSurvey extends Vue {

  changeTypeDiagramm(type: string) {
    this.typeDiagram = type
    this.chartOptions.chart.type = type
  }

  @Prop({type: Array, default: []}) items!: any
  @Prop({type: String, default: ''}) title!: any
  @Prop({type: String, default: ''}) titletable!: any

  itemCharts: any = this.items
  allCheck: boolean = false

  @Watch('$i18n.locale', { immediate: true })
  onLocaleChanged(_: any) {
    this.updateLocale()
  }

  updateLocale() {
    this.chartOptions.chart.height = this.currentHeight
    Highcharts.setOptions({
      lang: {
        shortMonths: locales[this.$i18n.locale]
      }
    })

    this.seriesConfig.countOfFilledSurveys.name = this.$t('newstatistics.visitor_badges_scanned.badges_scanned1')

    this.chartOptions.series[0] = { ...this.seriesConfig.countOfFilledSurveys, data: this.countOfFilledSurveys }
    this.chartOptions.xAxis.categories = this.categories

    const chart: any = this.$refs.charts
    if (!chart) return
    chart.chart.update({ ...this.chartOptions })
    // this.chartOptions.series[0].name = this.$t('newstatistics.visitor_badges_scanned.badges_scanned1')
  }


  @Watch('allCheck')
  get(NewVal: any) {
    if (NewVal) {
      this.itemCharts.map((ele: any) => {
        ele.show = true
      })
    } else {
      this.itemCharts.map((ele: any) => {
        ele.show = false
      })
    }
  }

  @Watch('filteredItems', {immediate: true, deep: true})
  getChartOptions(_: []) {
    setTimeout(() => this.updateSeries(), 100)
  }
  get hasStandmansWithData() {
    return this.filteredItems.some((standman: any) => standman.countOfFilledSurveys)
  }

  get filteredItems() {
    return this.itemCharts.filter((ele: any) => ele.show === true)
  }
  get countOfFilledSurveys() {
    if (!this.filteredItems.length) return []
    return this.filteredItems.map((item: any) => {
      return item.countOfFilledSurveys
    })
  }
  get categories() {
    if (!this.filteredItems.length) return []
    return this.filteredItems.map((item: any) => {
      return item.name
    })
  }

  get currentHeight() {
    return this.filteredItems.length > 12? String(this.filteredItems.length * 40) : '400'
  }

  updateSeries() {
    if (!this.itemCharts.length) return
    const chart: any = this.$refs.charts
    if (!chart) return
    chart.chart.update({
      series: [
        {
          ...this.seriesConfig.countOfFilledSurveys,
          data: this.countOfFilledSurveys
        },
      ],
      xAxis: {
        categories: this.categories
      }
    })
    const width = this.filteredItems.length * 40
    chart.chart.setSize(null, width < 400 ? 400 : width)
  }

  seriesConfig = {
    countOfFilledSurveys: {
      color: '#4E69CB',
      name: this.$t('newstatistics.visitor_badges_scanned.badges_scanned1'),
    },
  }

  typeDiagram = 'bar'

  chartOptions = {
    chart: {
      height: this.currentHeight,
      style: {"fontSize": "12px"},
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginRight: '30',
      marginTop: '30',
      marginBottom: '50',
      type: this.typeDiagram,
    },
    title: {
      text: ''
    },
    subtitle: {},
    credits: {
      enabled: false
    },
    tooltip: {
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0
      },
      formatter: function (): any {
        const context: any = this
        return '<div class="statistics-v4-tooltip">' + '<span class="statistics-v4-tooltip-title">'
          + context.x +
          '</span><br><span class="statistics-v4-tooltip-subtitle">'
          + context.series.name + ': ' + context.y + '</span></div>'
      },
    },
    xAxis: {
      allowDecimals: false,
      categories: this.categories,
      title: {
        text: null
      }
    },
    yAxis: {
      min: 0,
      allowDecimals: false,
      title: null,
      gridLineDashStyle: 'dot',
      gridLineWidth: 2,
      tickPixelInterval: 200,
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        legend: {
          enabled: true
        },
        colorByPoint: true,
        dataLabels: {
          enabled: true,
          inside: false
        }
      },
      pie: {
        chart: {
          marginLeft: 0,
          marginBottom: '10',
          height: '505'
        },
        legend: {
          enabled: false,
          align: 'left',
          verticalAlign: 'top',
          layout: 'vertical',
          x: 0,
          y: 100
        },
        cursor: 'pointer',
        dataLabels: {
          alignTo: 'plotEdges',
          style: {
            color:'black',
            shadow:false,
            textOverflow: 'clip'
          }
        },
        showInLegend: false,
        startAngle: -180,
        endAngle: 180,
        center: ['50%', '50%'],
        size: '90%',
        series: {
          innerSize: '50%',

        }
      },
      bar: {
        legend: {
          enabled: true
        },
        colorByPoint: false,
        dataLabels: {
          enabled: true,
          inside: false
        }
      },
    },
    series: [
      {
        ...this.seriesConfig.countOfFilledSurveys,
        data: this.countOfFilledSurveys
      }
    ]
  }

}
